module.exports = __webpack_public_path__ + "static/img/h12.571d15a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h12.jpg
// module id = /VZd
// module chunks = 0